module.exports = __webpack_public_path__ + "img/fond-2.88569ab4.png";